// extracted by mini-css-extract-plugin
export default {"root":"bottom-info-bar__root___twx7a","text":"bottom-info-bar__text___YNlEy","icon":"bottom-info-bar__icon___yzBfc"};